// Angular
import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';

// Services
import { MessagesService } from '../../services/message/messages.service';
import { LoginService } from 'src/app/services/login/login.service';
import { NgxSpinnerService } from 'ngx-spinner';

// Class/Data/Interface/Extra
import { ForgotEmail } from 'src/app/shared/classes';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.less']
})
export class ForgotPasswordComponent implements OnInit {
  public year = new Date().getFullYear();
  public forgotPasswordForm;

  constructor(private location: Location, private fb: FormBuilder, private login: LoginService, private msg: MessagesService,
    private router: Router, private load: NgxSpinnerService) { }

  ngOnInit() {
    this.initForm();
  }

  // inits forgot password form
  private initForm() {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  // go back
  public goBack() {
    this.location.back();
  }

  // submit email - for get email of forgot password
  public submitEmail() {
    this.load.show();

    const email = this.forgotPasswordForm.value.email;

    const emailObj = new ForgotEmail(email);

    this.login.requestForPasswordReset(emailObj)
      .then(msg => this.processSuccess(msg))
      .catch(error => this.processError(error));
  }

  // processes any success
  private processSuccess(message) {
    this.load.hide();
    // display success
    this.msg.success(message);
    this.msg.info('Check your email for reset password link');
    this.msg.info('Redirecting to login');

    setTimeout(() => {
      this.router.navigate(['/login']);
    }, 2000);
  }

  // processes any errors
  private processError(error) {
    this.load.hide();
    // display error
    this.msg.error(error);
  }
}
